// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import ReportModalContainer from '../../../../report/container/ReportModalContainer';

import commonStyle from '../../../components/OrderCommon.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import style from './Purchased.scss';

import type { Node } from 'react';
import type { Motive, MotiveKey } from '../../../../report/duck';
import type { LocaleState } from '../../../../locale/duck';
import type { Order } from '../../../../../entities';

type Props = {
  +buildStatusBoard: () => Node;
  +buildProducts: () => Node;
  +buildSummary: () => Node;
  +buildTravelerInfo: () => Node;

  +motives?: { [key: MotiveKey]: Motive[] };
  +locale: LocaleState;
  +order: Order;
};

type State = {
  reportModalVisible: boolean;
};
export default class Purchased extends Component<Props, State> {
  state = {
    reportModalVisible: false,
  };

  handleCloseReportModal = () => {
    this.setState({ reportModalVisible: false });
  };

  handleOpenReportModal = () => {
    this.setState({ reportModalVisible: true });
  };

  render() {
    const { buildStatusBoard, buildProducts, buildSummary, buildTravelerInfo, motives, locale, order } = this.props;
    const { reportModalVisible } = this.state;
    const options = motives ? motives.purchaser.map((motive: Motive) => ({
      value: motive.name,
      label: motive.translations[locale.locale.toUpperCase()],
    })) : [];
    return (
      <Fragment>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            {buildStatusBoard()}
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildTravelerInfo()}
            {buildSummary()}
            <FormattedMessage id="order.purchase.purchased.report.button">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.redInverse, style.report)}
                             onClick={this.handleOpenReportModal}>{txt}</button>
            }</FormattedMessage>
          </section>
        </main>
        <ReportModalContainer color="lightBlue"
                              reportType="PURCHASER_TRACKING"
                              isOpen={reportModalVisible}
                              handleClose={this.handleCloseReportModal}
                              isDiy={order.isDiy}
                              id={order.id}
                              options={options}
                              successIntl="modal.report.purchaser.success.text"/>
      </Fragment>
    );
  }
}

Purchased.propTypes = {
  buildStatusBoard: PropTypes.func.isRequired,
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
  buildTravelerInfo: PropTypes.func.isRequired,
  motives: PropTypes.object,
  locale: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/purchased/components/Purchased.jsx